module.exports = __webpack_public_path__ + "static/home-front-59363f47d170819172df33e773d704a8.png";